import PropTypes from 'prop-types'
import Icon from 'components/Icon'
import { stopPropagation } from 'utils'
import {
  applyUserPreset,
  showPresetConfigModal,
} from 'features/dashboard/table/config/tableConfigSlice'
import { useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'
import NoneAnchor from 'components/NoneAnchor'
import { useDashboardTypeName } from 'features/dashboard/utils/hooks/useDashboardTypeName'

export const UserPresetListItem = ({
  userPreset: { name, id },
  handleListClose,
  handleDelete,
}) => {
  const { type: domainType } = useDashboardTypeName()
  const dispatch = useDispatch()
  const selectedUserPresetId = useSelector(
    ({ dashboard }) => dashboard.table.config.selectedUserPresetId[domainType]
  )

  const handleSelect = () => {
    dispatch(
      applyUserPreset({
        id,
        domainType,
      })
    )
    handleListClose()
  }

  return (
    <li
      className={classNames('user_opt', { on: selectedUserPresetId === id })}
      onClick={handleSelect}>
      <NoneAnchor className="link_option">{name}</NoneAnchor>
      <NoneAnchor
        className="btn_edit"
        onClick={event => {
          event.stopPropagation()
          dispatch(
            showPresetConfigModal({
              domainType,
              editing: id,
            })
          )
        }}>
        <Icon name="edit">수정</Icon>
      </NoneAnchor>
      <NoneAnchor
        className="btn_del"
        onClick={stopPropagation(() => handleDelete(id))}>
        <Icon name="del">삭제</Icon>
      </NoneAnchor>
    </li>
  )
}

UserPresetListItem.propTypes = {
  handleListClose: PropTypes.func,
  handleDelete: PropTypes.func,
  userPreset: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.string,
  }),
}
